import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaDetalleDifProducto from "../components/TablaDetalleDifProducto";
import {diferenciasResources} from "../endpoints";
import CardTotales from "../components/CardTotales";

class DetalleDifProducto extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            producto: "",
            idProducto: props.match.params.idProducto,
            origen: props.match.params.origen,
            datosProducto:{}
        }
    }

    componentDidMount() {
        this.obtenerDescripcion()
    }

    obtenerDescripcion = () =>{
        diferenciasResources.getDatosProducto(this.state.idProducto,'articulo').then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({producto:result.descripcion, datosProducto:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>Detalle diferencia del producto: {this.state.idProducto} {this.state.producto}</Typography>
                <CardTotales datos={this.state.datosProducto}/>
                <br/>
                <TablaDetalleDifProducto  idProducto={this.state.idProducto} tipo={'diferencias'} origen={this.state.origen}/>
            </div>
        )
    }
}

export default DetalleDifProducto;